import axios from "axios";
import { apiHeaders } from "../helper/apiHeader";
import moment from "moment";
import { message } from "antd";
import { getStudentData } from "../helper/localStorage";

export const processAudio = (
  question,
  studentData,
  recordedBlob,
  dispatchAnswer,
  dispatchHelper,
  testType,
  shuffeledImage
) => {
  dispatchAnswer({ type: "IS_LOADING", payload: true });
  let formData = new FormData();
  const filename = new Date().toLocaleString();
  const duration = recordedBlob.stopTime - recordedBlob.startTime;
  const varGradeId =
    testType === "CALIBRATION"
      ? "5"
      : JSON.parse(localStorage.getItem("gradeId"));

  console.log("duration", duration);

  console.log(
    "question.test_format, shuffeledImage",
    question.test_format,
    shuffeledImage
  );

  formData.append("file", recordedBlob.blob, filename);
  formData.append(
    "file_name",
    `${studentData.login_id}_${moment().format("YYYYMMDDhhmmss")}.wav`
  );
  formData.append("file_length", duration);
  formData.append("player_id", studentData.login_id);
  formData.append("grade_id", varGradeId);
  formData.append("test_id", question.test_id);
  formData.append("que_id", question.id);
  formData.append(
    "que_time",
    localStorage.getItem("timeSpend")
      ? Math.floor(localStorage.getItem("timeSpend") / 1000)
      : 0
  );
  formData.append("test_format", question.test_format);
  // formData.append("que_ids", shuffeledImage);
  formData.append(
    "que_ids",
    testType === "CALIBRATION"
      ? ""
      : question.test_format === "listen_speak_series"
      ? question.questionArray.reduce(
          (str, que, i) => `${str}${i !== 0 ? "," : ""}${que.id}`,
          ""
        )
      : ""
  );

  axios
    .post("/UserTestData", formData, {
      headers: {
        ...apiHeaders("processaudio").headers,
        'Content-Type': 'mutlipart/form-data'
      }
    })
    .then((res) => {
      if (res.data.status === "201") {
        console.log("processAudio", res.data);
        dispatchAnswer({
          type: "PROCESSED_AUDIO",
          que_id: question.id,
          section_name: question.section_name,
          payload: res.data,
          que_time: localStorage.getItem("timeSpend")
            ? Math.floor(localStorage.getItem("timeSpend") / 1000)
            : 0,
        });
        localStorage.removeItem("timeSpend");
        dispatchHelper({ type: "IS_NEXT_QUES", payload: true });
        return;
      } else {
        message.error(
          !!res.data.msg
            ? res.data.msg
            : "Please wait for sometime or check your internet connection. Try again"
        );
        dispatchAnswer({ type: "IS_ERR" });
      }
    })
    .catch((err) => {
      dispatchAnswer({ type: "IS_ERR" });
      console.log(err);
    })
    .finally(() => {
      question.test_format === "listen_speak_series" &&
        dispatchHelper({ type: "RESET_SHUFFELED_IMAGE" });
    });
};
